import { get } from 'lodash'

const initialState = { status: false }

export default function loaderReducer(state = initialState, action) {
  const { type } = action
  const matches = /(.*)_(REQUEST|SUCCESS|FAILURE)/.exec(type)

  // not a *_REQUEST / *_SUCCESS /  *_FAILURE actions, so we ignore them
  if (!matches) return state

  const [, requestName, requestState] = matches
  return {
    ...state,
    [requestName]: requestState === 'REQUEST',
  }
}

export const createLoadingSelector = (actions) => (state) =>
  actions.some((action) => get(state, action))
